<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-container" :style="{ minWidth: minWidth }">
        <div class="d-flex align-items-start w-100">
          <div class="modal-nav">
            <slot name="backAction" class="text-start" />
          </div>
          <div class="modal-title">
            <slot name="header">
              <span class="text-primary text-start title title-size">{{ title }}</span>
            </slot>
          </div>
          <div v-if="!hideClose" class="modal-close mt-1">
            <button type="button" class="btn-close text-end" @click="$emit('onClose')"></button>
          </div>
        </div>

        <div class="modal-body">
          <slot name="body">default body</slot>
        </div>

        <div class="modal-footer" :style="`justify-content :${alignFooter} `">
          <slot name="footer">
            <button
              v-if="!hideCancel"
              class="btn btn-link"
              @click="
                $emit('onClose');
                $emit('onCancel');
              ">
              {{ cancelText }}
            </button>
            <button
              v-if="!hideSubmit"
              class="btn btn-primary"
              @click="
                $emit('onClose');
                $emit('onSubmit');
              ">
              {{ submitText }}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
  defineProps({
    show: Boolean,
    title: {
      type: String,
      default: null,
    },
    hideSubmit: {
      type: Boolean,
      default: false,
    },
    submitText: {
      type: String,
      default: 'Accept',
    },
    hideCancel: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    alignFooter: {
      validator(value) {
        return ['left', 'center', 'right'].includes(value);
      },
      default: 'right',
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
    minWidth: {
      type: String,
      default: '70vw'
    }
  });

  defineEmits(['onClose', 'onSubmit', 'onCancel']);
</script>

<style>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    transition: opacity 0.3s ease;
  }

  .modal-container {
    max-width: 600px;
    margin: auto;
    padding: 20px 30px;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    border-radius: var(--bs-border-radius-xl);

    @media only screen and (max-width: 768px) {
      padding: 20px 15px;
    }
  }

  .modal-footer {
    border-top: none !important;
  }

  .modal-body {
    margin: 10px 0;
    max-height: 79vh;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .modal-default-button {
    float: right;
  }

  .title-size {
    font-weight: 600;
    font-size: 20px;
  }

  .modal-enter-from {
    opacity: 0;
  }

  .modal-leave-to {
    opacity: 0;
  }

  .modal-enter-from .modal-container,
  .modal-leave-to .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  @media screen and (max-width: 768px) {
    .modal-container {
      /* //margin: auto 0.5rem; */
      width: 95%;
    }
  }

  .modal-nav,
  .modal-title,
  .modal-close {
    flex: 0 0 auto;
  }

  .modal-title {
    flex: 1;
    word-wrap: break-word;
    overflow-wrap: break-word;
    padding-right: 0.5rem;
  }
</style>
